import { isNil } from '@lucidlink/tscore';
function isNode() {
    return typeof process !== 'undefined' && !isNil(process.versions) && !isNil(process.versions.node);
}
export function isTest() {
    if (isNode()) {
        const mode = process.env['MODE'];
        return !isNil(mode) && mode === 'test';
    }
    else {
        return '__vitest_browser__' in globalThis;
    }
}
